import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import LandingPageBuySectionAppResource from './LandingPageBuySectionAppResource';
import LandingPageFinanceSectionAppResource from './LandingPageFinanceSectionAppResource';
import LandingPageHomeSectionAppResource from './LandingPageHomeSectionAppResource';
import LandingPageLinkAppResource from './LandingPageLinkAppResource';
import LandingPagePhoneAppResource from './LandingPagePhoneAppResource';
import LandingPageSellSectionAppResource from './LandingPageSellSectionAppResource';
import LandingPageSocialLinkAppResource from './LandingPageSocialLinkAppResource';
import LandingPageTradeSectionAppResource from './LandingPageTradeSectionAppResource';
import LuLandingPageTypeAppResource from './LuLandingPageTypeAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import UserAppResource from './UserAppResource';
import WorkspaceAppResource from "./WorkspaceAppResource";
import get from 'lodash/get'
import LandingPageHomeLoanOfficerAppResource from "./LandingPageHomeLoanOfficerAppResource";
import LandingPageLearnSectionAppResource from "./LandingPageLearnSectionAppResource";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";
import isEmpty from "lodash/isEmpty";
import LandingPageEventAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageEventAppResource";
import PlaybookAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/PlaybookAppResource";

export const SECTIONS = {
    HOME: 'home',
    BUY: 'buy',
    SELL: 'sell',
    FINANCE: 'finance',
    TRADE: 'trade',
    LEARN: 'learn',
}
export const MANUAL = 'manual_archive';
export const AUTO = 'auto_archive';
export const ARCHIVE_TYPES = {
    MANUAL,
    AUTO,
}

class LandingPageAppResource extends AppResource {

    /**
     *
     * @returns {string}
     */
    get publicUrl() {

        if (!this.urlSuffix) {
            console.warn('Url Suffix missing on landing page public url!');
            return '';
        }

        const MILESTONES_WEBSITE_HOST = window.env.MILESTONES_WEBSITE_HOST;
        if (!MILESTONES_WEBSITE_HOST) {
            console.warn('MILESTONES_WEBSITE_HOST missing on landing page public url!');
            return '';
        }
        if (!this.organization) {
            console.warn('Organization missing on landing page public url!');
            return '';
        }

        const prefix = this.organization.brandingPath;
        if (!prefix) {
            console.warn('Organization branded login missing on landing page public url!');
            return '';
        }

        const protocol = MILESTONES_WEBSITE_HOST.indexOf('https://') === 0 ? 'https://' : 'http://';
        const host = MILESTONES_WEBSITE_HOST.replace(protocol, '');

        return new URL([protocol, prefix, '.', host, '/landing-page/', this.urlSuffix].join(''));
    }

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'landing-page';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'landings/pages';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'typeId',
            'archivedAt',
            'public',
            'primaryColor',
            'title',
            'urlSuffix',
            'notice',
            'syncUserProfile',
            'userUuid',
            'avatarFileUuid',
            'firstName',
            'lastName',
            'displayName',
            'email',
            'syncOrganization',
            'organizationUuid',
            'organizationName',
            'organizationLogoUuid',
            'phones',
            'links',
            'socialLinks',
            'landingPageType',
            'sell',
            'home',
            'buy',
            'finance',
            'trade',
            'user',
            'avatar',
            'organization',
            'organizationLogo',
            'actions',
            'learn',
            'callToActionCounter',
            'viewed',
            'hasEvent',
            'event',
            'homeOwnershipPlaybookUuid',
            'homeOwnershipPlaybook',
            'archiveType',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            phones:             LandingPagePhoneAppResource,
            links:             LandingPageLinkAppResource,
            socialLinks:             LandingPageSocialLinkAppResource,
            landingPageType:             LuLandingPageTypeAppResource,
            sell:             LandingPageSellSectionAppResource,
            home:             LandingPageHomeSectionAppResource,
            buy:             LandingPageBuySectionAppResource,
            finance:             LandingPageFinanceSectionAppResource,
            trade:             LandingPageTradeSectionAppResource,
            user:             UserAppResource,
            avatar:             FileAppResource,
            organization:             OrganizationAppResource,
            organizationLogo:             FileAppResource,
            projects: WorkspaceAppResource,
            loanOfficer: LandingPageHomeLoanOfficerAppResource,
            socialLinksLoanOfficer: LandingPageSocialLinkAppResource,
            phonesLoanOfficer: LandingPagePhoneAppResource,
            learn: LandingPageLearnSectionAppResource,
            event: LandingPageEventAppResource,
            homeOwnershipPlaybook: PlaybookAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            landingPageType: 'type_id',
            user: 'user_uuid',
            avatar: 'avatar_file_uuid',
            organization: 'organization_uuid',
            organizationLogo: 'organization_logo_uuid',
            homeOwnershipPlaybook: 'home_ownership_playbook_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            typeId: {
                type: 'integer',
                presence: true,
            },
            public: {
                type: 'boolean',
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    minimum:1,
                    maximum:255,
                    tooShort:'is required!'
                },
            },
            urlSuffix: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            syncUserProfile: {
                type: 'boolean',
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            avatarFileUuid: {
                type: 'string',
            },
            firstName: {
                type: 'string',
                presence: true,
                length:{
                    minimum:1,
                    maximum:255,
                    tooShort:'is required!'
                }
            },
            lastName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                    tooShort:'is required!'
                },
            },
            displayName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            email: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            syncOrganization: {
                type: 'boolean',
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            organizationName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                    tooShort:'is required!'
                },
            },
            organizationLogoUuid: {
                type: 'string',
            },
            archivedAt: {
                datetime: true,
            },
            callToActionCounter: {
                type: 'integer'
            },
            viewed: {
                datetime: true,
            },
            notice: {
                type: 'string',
            },
            hasEvent: {
                type: 'boolean',
            },
            homeOwnershipPlaybookUuid: {
                type: 'string',
                presence: true,
            },
            archiveType: {
                type: 'string',
            },
            primaryColor: {
                type: 'string',
            },
        };
    }

    apiPaths() {
        return {
            ...super.apiPaths(),
            action: Engine.apiUrl(`${this.appResourceApiPrefix()}/{uuid}/action`)
        };
    }

    async action() {
        if (this.uuid === null) {
            throw new Error('Uuid is missing!');
        }

        let updateData = {};

        if (this.isDirty) {
            const validationErrors = this.validateExisting(false);
            if (!isEmpty(validationErrors)) {
                if (Engine.debug) {
                    const resourceType = this.resourceType;
                    console.warn(
                        'Cannot update invalid ' + resourceType,
                        validationErrors,
                    )
                }
                return Promise.reject('Attributes validation not passed!')
            }
            updateData = this.buildUpdateData(false)
        }

        const url = this.apiPaths().action.replace('{uuid}', this.uuid);

        return await this.enginePost(url, updateData);
    }

}

export default LandingPageAppResource;
